(function() {
  'use strict';

  angular
    .module('admin.tips.service', [])
    .factory('TipsAdminService', TipsAdminService);

  /** @ngInject */
  function TipsAdminService($http, $q, API) {

    function list(start, limit, sort){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/tips?start=' + start + '&limit=' + limit + '&sort=' + sort)
          .success(defered.resolve);

        return defered.promise;
    }

    function get(id){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/tips/' + id)
          .success(defered.resolve);

        return defered.promise;
    }

    function save(model){
        var defered = $q.defer();

        $http.post(API.API_URL + 'admin/tips', model)
          .success(defered.resolve)
          .error(function(result){
            swal(result.error.message, "", "error");
          });

        return defered.promise;
    }

    function update(id, model){
        var defered = $q.defer();

        $http.put(API.API_URL + 'admin/tips/' + id, model)
          .success(defered.resolve)
          .error(function(result){
            swal(result.error.message, "", "error");
          });

        return defered.promise;
    }

    function remove(id){
        var defered = $q.defer();

        $http.delete(API.API_URL + 'admin/tips/' + id)
          .success(defered.resolve)
          .error(function(result){
            swal(result.error.message, "", "error");
          });

        return defered.promise;
    }

    return{
        list: list,
        get: get,
        save: save,
        update: update,
        remove: remove
    };

  }

})();
